<template>

  <div class="p-fluid report-field">
    <div :class="['p-grid report-field-header', {'report-field-header-small':section==='REPORT'}]">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center">
        <label :for="guide.key">{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
    </div>
    <div>

      <Calendar :id="guide.key" v-if="!overview" v-model="myDate" dateFormat="dd/mm/yy" :manualInput="false"
              :placeholder="$t('report.'+section+'.'+guide.key+'_ph')"
              @date-select="dataChanged($event)" 
              :disabled="guide.disabled"
              :class="{'p-invalid':guide.invalid}"/>

      <span v-else>{{ formattedDate ?? '-' }}</span>

    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      myDate: null
    }
  },
  computed: {
    formattedDate() {
      return this.myDate ? new this.$moment(this.myDate).format("DD/MM/YYYY") : null;
    }
  },
  created() {
    this.myDate = this.data[this.guide.key] ? new this.$moment(this.data[this.guide.key], "DD/MM/YYYY").toDate() : null;
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(newValue) {
      let formattedDate = new this.$moment(newValue).format("DD/MM/YYYY");
      this.$emit("update:data", { key: this.guide.key, value: formattedDate });
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.myDate = null;
      }
    }
    
  }
}
</script>

<style scoped>

</style>